import React from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "./../../../../../../../../assets/css/Dashboard/Claim.scss";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

export default function Claimed(props) {
  const StatusIcon = (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    ></svg>
  );

  const gridStyle = { height: "100%", width: "100%" };

  const PatientColumns = [
    {
      field: "selected",
      width: 0,
      selected: false,
      headerClass: "defaultGridHeaderCol",
      filter: false,
      floatingFilter: false,
    },
    {
      headerName: "Patient name",
      field: "patientName",
      sortable: true,
      editable: false,
    },
    {
      headerName: "Telephone Number",
      field: "telephoneNumber",
      sortable: true,
      editable: false,
      selected: false,
    },
    {
      headerName: "Date of Birth",
      field: "dob",
      sortable: true,
      editable: false,
      selected: false,
      valueFormatter: (params) => {
        if (params.value && params.value !== "0001-01-01T00:00:00Z") {
          const date = new Date(params.value);
          return date.toLocaleDateString("en-GB");
        } else {
          return "-";
        }
      },
      filterValueGetter: (params) => {
        if (params.data?.dob && params.data.dob !== "0001-01-01T00:00:00Z") {
          return new Date(params.data.dob).toLocaleDateString("en-GB");
        }
        return "-";
      },
    },
    {
      headerName: "Service Name",
      field: "serviceName",
      sortable: true,
      editable: false,
      selected: false,
    },
    {
      headerName: "Date of Nms",
      field: "serviceDate",
      sortable: true,
      editable: false,
      valueFormatter: (params) => {
        const date = new Date(params.value);
        const options = { day: "2-digit", month: "2-digit", year: "numeric" };
        return date?.toLocaleDateString("en-GB", options);
      },
      filterValueGetter: (params) => {
        if (params.data?.serviceDate) {
          const options = { day: "2-digit", month: "2-digit", year: "numeric" };
          return new Date(params.data.serviceDate).toLocaleDateString("en-GB", options);
        }
        return "-";
      },
    },
    {
      headerName: "Drug Name",
      field: "drugName",
      sortable: true,
      editable: false,
      selected: false,
    },
    {
      headerName: "Completed By",
      field: "completedBy",
      sortable: true,
      editable: false,
      selected: false,
    },
    {
      headerName: "Completed Date",
      field: "createdOn",
      sortable: true,
      editable: false,
      valueFormatter: (params) => {
        const date = new Date(params.value);
        const options = { day: "2-digit", month: "2-digit", year: "numeric" };
        return date.toLocaleDateString("en-GB", options);
      },
      filterValueGetter: (params) => {
        if (params.data?.createdOn) {
          const options = { day: "2-digit", month: "2-digit", year: "numeric" };
          return new Date(params.data.createdOn).toLocaleDateString(
            "en-GB",
            options,
          );
        }
        return "-";
      },
    },
    {
      headerName: "Stage",
      field: "stageType",
      sortable: true,
      editable: false,
      valueGetter: (params) => {
        switch (params.data.stageType) {
          case 3:
            return "Intervention";
          case 4:
            return "Followup";
          default:
            return "Intervention";
        }
      },
    },
    {
      headerName: "Status",
      field: "status",
      sortable: true,
      editable: false,
      cellRendererFramework: StatusIcon,
      valueGetter: (params) => {
        switch (params.data.status) {
          case 0:
            return "Completed";
          case 1:
            return "Completed";
          case 2:
            return "Completed";
          case 3:
            return "Completed";
          default:
            return params?.data?.status;
        }
      },
    },
  ];

  const gridOptions = {
    suppressMovableColumns: true,
    getRowClass: (params) => (params?.node?.isSelected ? "selected-row" : ""),
    onRowClicked: (event) => {
      if (props.onRowClick) {
        props.onRowClick(event.data);
      }
    },
  };

  const exportToCSV = (apiData, fileName) => {
    const modifiedData = apiData?.map((item) => {
      const statusMap = {
        0: "Completed",
        1: "Completed",
        2: "Completed",
        3: "Completed",
      };
      const stage = {
        3: "Intervention",
        4: "Followup",
      };

      return {
        "Patient Name": item.patientName || "-",
        "Telephone Number": item.telephoneNumber || "-",
        "Date of Birth":
          item.dob && item.dob !== "0001-01-01T00:00:00Z"
            ? new Date(item.dob).toLocaleDateString("en-GB")
            : "-",
        "Service Name": item.serviceName || "-",
        "Date of Nms": item.serviceDate
          ? new Date(item.serviceDate).toLocaleDateString("en-GB")
          : "-",
        "Drug Name": item.drugName ? `${item.drugName}` : "-",
        "Completed By": item.completedBy || "-",
        "Completed Date": item.createdOn
          ? new Date(item.createdOn).toLocaleDateString("en-GB")
          : "-",
        Stage: stage[item.stageType] ?? "Intervention",
        Status: statusMap[item.status] ?? item.status ?? "-",
      };
    });

    const ws = XLSX.utils.json_to_sheet(modifiedData);
    const csv = XLSX.utils.sheet_to_csv(ws);
    const csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    FileSaver.saveAs(csvData, `${fileName}.csv`);
  };

  return (
    <div
      style={gridStyle}
      className={
        props?.darkMode === true ? "ag-theme-alpine-dark" : "ag-theme-alpine"
      }
    >
      {props?.claimedServices?.length !== 0 ? (
        <>
          <div
            style={{
              height: "500px",
            }}
          >
            <AgGridReact
              rowData={props?.claimedServices}
              columnDefs={PatientColumns}
              gridOptions={gridOptions}
              defaultColDef={{
                sortable: true,
                floatingFilter: true, // enable search bar under headers
                resizable: true,
                filter: "agTextColumnFilter", // basic text filter
                floatingFilterComponentParams: { suppressFilterButton: true }, // hides funnel icon
              }}
            />
          </div>
          <div className="analytics_tab_list_footer">
            <button
              onClick={(e) => exportToCSV(props?.claimedServices, "ClaimedFile")}
            >
              <p>Export</p>
            </button>
          </div>
        </>
      ) : (
        <div>
          <h4>No Data To Show</h4>
        </div>
      )}
    </div>
  );
}
